import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from '#src/shared/prefetch';

import { PetitionGuidesPageContextProvider, prefetchPageContext } from '#src/app/pages/petitionGuides/pageContext';
import type { PetitionGuidesPagePrefetchedDataProps } from '#src/app/pages/petitionGuides/pageContext';
import { isLoaded } from '#src/app/shared/utils/async';

import { Layout } from '../layout';

import { PetitionGuidesErrorHandler } from './ErrorHandler';

export const PetitionGuidesLandingPage = withPrefetchedData(
	function PetitionGuides({ prefetchedData }: PetitionGuidesPagePrefetchedDataProps) {
		return (
			<PetitionGuidesPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={PetitionGuidesErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</PetitionGuidesPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		pageTitle: ({ i18n, fromTemplate }) => {
			return fromTemplate(i18n.translate('corgi.petition_guides_landing_page.meta.title'));
		},
		pageCanonical: () => '/petition-guides',
		pageMetadata: ({ prefetchedData, i18n }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			const description = i18n.translate('corgi.petition_guides_landing_page.meta.description');
			const title = i18n.translate('corgi.petition_guides_landing_page.meta.title');
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				ogImage: prefetchedData.pageData.pageData.heroImage.url,
				ogType: 'website' as const,
			};
		},
		pageAlternateUrls: () => ({
			'en-US': '/petition-guides',
		}),
	},
);
